import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";

const buttonVariants = cva("", {
  variants: {
    variant: {
      primary: "primary-button",
      secondary: "secondary-button",
      danger: "secondary-button danger-button",
    },
    size: {
      default: "",
      compact: "compact-button",
    },
    active: {
      true: "is-active",
      false: "",
    },
  },
  defaultVariants: {
    variant: "secondary",
    size: "default",
    active: false,
  },
});

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, active, type = "button", ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(buttonVariants({ variant, size, active }), className)}
      {...props}
    />
  ),
);

Button.displayName = "Button";
